<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14 19C14 19.8898 15.0608 20.3193 15.681 19.7331L15.7593 19.6508L21.7593 12.6508C22.0535 12.3076 22.078 11.8146 21.8328 11.4464L21.7593 11.3493L15.7593 4.34926C15.1802 3.67373 14.0953 4.038 14.0059 4.88665L14 5.00005V8.00005L12.962 8.08655C6.86586 8.59456 2.15411 13.6166 2.00371 19.7L2 20L4.65878 18.4807C7.36138 16.9364 10.4024 16.0875 13.509 16.0065L14 16V19Z"
    fill="currentColor"
  />
</svg>
